import React from 'react';

const PodcastIcon = ({
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "17",
    height: "18",
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1 11.8125C1 11.3152 1.19754 10.8383 1.54917 10.4867C1.90081 10.135 2.37772 9.9375 2.875 9.9375H3.8125C4.30978 9.9375 4.78669 10.135 5.13832 10.4867C5.48996 10.8383 5.6875 11.3152 5.6875 11.8125V14.625C5.6875 15.1223 5.48996 15.5992 5.13832 15.9508C4.78669 16.3025 4.30978 16.5 3.8125 16.5H2.875C2.37772 16.5 1.90081 16.3025 1.54917 15.9508C1.19754 15.5992 1 15.1223 1 14.625V11.8125ZM1 11.8125V9C1 7.01088 1.79018 5.10322 3.1967 3.6967C4.60322 2.29018 6.51088 1.5 8.5 1.5C10.4891 1.5 12.3968 2.29018 13.8033 3.6967C15.2098 5.10322 16 7.01088 16 9V11.8125M16 11.8125C16 11.3152 15.8025 10.8383 15.4508 10.4867C15.0992 10.135 14.6223 9.9375 14.125 9.9375H13.1875C12.6902 9.9375 12.2133 10.135 11.8617 10.4867C11.51 10.8383 11.3125 11.3152 11.3125 11.8125V14.625C11.3125 15.1223 11.51 15.5992 11.8617 15.9508C12.2133 16.3025 12.6902 16.5 13.1875 16.5H14.125C14.6223 16.5 15.0992 16.3025 15.4508 15.9508C15.8025 15.5992 16 15.1223 16 14.625V11.8125Z",
      stroke: "white",
      "stroke-width": "1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  )
);

export { PodcastIcon };
//# sourceMappingURL=PodcastIcon.js.map
